var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Observable } from 'rxjs';
var CustomerProfileComponent = /** @class */ (function () {
    function CustomerProfileComponent(apiService, util, fb, activatedRoute) {
        this.apiService = apiService;
        this.util = util;
        this.fb = fb;
        this.activatedRoute = activatedRoute;
        this.contactId = "";
        this.submitted = false;
        this.isEndCase = false;
        this.isCrisis = true;
        this.crm06 = {};
        this.isNDID = false;
        this.isDOPA = false;
        this.isAgentBank = false;
        this.dpa_allowemail = false;
        this.dpa_allowsms = false;
        this.dpa_pdpa_flag = false;
        this.createBy = "";
        this.modifiedBy = "";
        this.createContactBy = "";
        this.modifyContactBy = "";
        this.role = {};
        this.agentList = [];
        this.userIdReceive = "";
        this.userList = [];
        this.forwardRemark = "";
        this.submittedForward = false;
        this.kmCriteria = "";
        this.showingKBList = [];
        this.isRemarkRequired = false;
        this.isResolvedRequired = false;
        this.oldEmail = "";
        //personalTypeList: any = {}
        this.stakeHolderList = [];
        this.GetDataSave = new EventEmitter();
        this.form = this.fb.group({
            contactid: "",
            dpa_contacttype: "",
            firstname: "",
            lastname: "",
            dpa_stakeholderid: "",
            dpa_idcard: "",
            dpa_passport: "",
            birthdate: "",
            dpa_companyname: "",
            dpa_registrationdate: "",
            dpa_authorizedperson: "",
            dpa_authorizedperson_idcard: "",
            dpa_authorizedperson_telephone: "",
            telephone1: ['', Validators.required],
            dpa_otherphone: "",
            emailaddress1: ['', this.emailValidator],
            dpa_contact_homeno: "",
            dpa_contact_building: "",
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: "",
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_country: "",
            dpa_registration_homeno: "",
            dpa_registration_building: "",
            dpa_registration_moo: "",
            dpa_registration_street: "",
            dpa_registration_subdistict: "",
            dpa_registration_distict: "",
            dpa_registration_province: "",
            dpa_registration_postcode: "",
            dpa_registration_country: "",
            dpa_dopaflag: "",
            dpa_ndidflag: "",
            dpa_agentbankflag: "",
            dpa_verifydate: "",
            dpa_facebookflag: "",
            dpa_googleflag: "",
            dpa_lineflag: "",
            statusreason: "",
            incidentid: "",
            ticketnumber: "",
            title: "",
            customerid: "",
            dpa_casetypeid: ['', Validators.required],
            dpa_casesubtypeid: ['', Validators.required],
            dpa_casesubtypedetailid: ['', Validators.required],
            dpa_casechannelid: new FormControl({ value: '', disabled: true }, Validators.required),
            dpa_caseseverityid: ['', Validators.required],
            description: ['', Validators.required],
            dpa_remark: "",
            dpa_casestatusid: ['', Validators.required],
            dpa_resolveddate: "",
            dpa_createdby: "",
            dpa_modifiedby: "",
            dpa_caseowner: "",
            dpa_resolveby: "",
            dpa_assignby: "",
            dpa_resolution: "",
            dpa_owningteamid: "",
            dpa_allowemail: false,
            dpa_allowsms: false,
            dpa_pdpa_flag: false
        });
    }
    CustomerProfileComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.util.InitValidation();
                        console.log("profile on init");
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        console.log(this.role);
                        this.myTeams = JSON.parse(this.cookieData.teams);
                        this.isCrisis = this.cookieData.isCrisis;
                        this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
                        if (this.isCrisis) {
                            this.crisis();
                        }
                        else {
                            this.normal();
                        }
                        return [4 /*yield*/, this.initDropdown()];
                    case 1:
                        _a.sent();
                        $("#userIdReceive").on("change", function () {
                            thisTs.userIdReceive = $("#userIdReceive").find('option:selected').val();
                        });
                        $("#ra2")[0].checked = true;
                        $("#ra1").on("click", function () {
                            $("#ra1")[0].checked = true;
                            $("#ra2")[0].checked = false;
                        });
                        $("#ra2").on("click", function () {
                            $("#ra1")[0].checked = false;
                            $("#ra2")[0].checked = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.init = function (contact) {
        var contacts = [];
        contacts.push(contact);
        this.initViewMode(contacts);
    };
    CustomerProfileComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                Observable.forkJoin(this.apiService.get("master", "caseChannel"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseSeverity"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "stakeHolders"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "callcenterTeam"), this.apiService.get("crmservice", "contact", "contactid=" + this.contactId)).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var tmpSubTypeDetail, contact, para, _a, channel, status;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                this.caseChannelList = data[0];
                                this.caseStatusList = data[1];
                                this.caseSeverityList = data[2];
                                this.caseTypeList = data[3];
                                this.subTypeTmpList = data[4];
                                this.stakeHolderList = data[5];
                                tmpSubTypeDetail = data[6];
                                this.teamList = data[7];
                                contact = data[8];
                                this.contactToDros = data[8];
                                para = "";
                                this.teamList.forEach(function (t) {
                                    if (para != "") {
                                        para += "&";
                                    }
                                    para += "callcenterteam=" + t.dpa_callcenterteamid;
                                });
                                _a = this;
                                return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                            case 1:
                                _a.agentList = _b.sent();
                                this.subTypeDetailTmpList = tmpSubTypeDetail.filter(function (s) {
                                    return !s.dpa_issendemail;
                                });
                                channel = this.caseChannelList.filter(function (ch) {
                                    return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter";
                                });
                                if (channel == null || channel.length > 0) {
                                    this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid);
                                }
                                status = this.caseStatusList.filter(function (ch) {
                                    return ch.dpa_name.replace(" ", "").toLowerCase() == "new";
                                });
                                if (status == null || status.length > 0) {
                                    this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid);
                                }
                                this.initViewMode(contact);
                                this.util.ShowWaiting(false);
                                return [2 /*return*/];
                        }
                    });
                }); }, function (err) { return console.error(err); });
                return [2 /*return*/];
            });
        });
    };
    CustomerProfileComponent.prototype.forward = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var caseStatus, caseForwardSubTypeDetail_1, matchTeam, matchUser, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
                            (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0))) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!this.form.valid) return [3 /*break*/, 10];
                        caseStatus = this.caseStatusList.filter(function (s) {
                            return s.dpa_casestatusid == _this.formControl["dpa_casestatusid"].value;
                        });
                        if (!(caseStatus != null && caseStatus.length > 0 && (caseStatus[0].dpa_name.toLowerCase() == "new" || caseStatus[0].dpa_name.toLowerCase() == "inprogress"))) return [3 /*break*/, 9];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 8]);
                        caseForwardSubTypeDetail_1 = this.subTypeDetailTmpList.filter(function (st) {
                            return st.dpa_casesubtypedetailid == _this.formControl["dpa_casesubtypedetailid"].value;
                        });
                        matchTeam = this.teamList.filter(function (t) {
                            return t.dpa_callcenterteamid == caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        });
                        if (!(matchTeam != null && matchTeam.length > 0)) return [3 /*break*/, 4];
                        this.forwardTeam = caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 3:
                        _a.sent();
                        matchUser = this.userList.filter(function (u) {
                            return u.dpa_customwebuserid == caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        });
                        if (matchUser != null && matchUser.length > 0) {
                            this.userIdReceive = caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        }
                        else {
                            this.userIdReceive = "";
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.forwardTeam = "";
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1 = _a.sent();
                        console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้");
                        this.forwardTeam = "";
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 7:
                        _a.sent();
                        this.userIdReceive = "";
                        return [3 /*break*/, 8];
                    case 8:
                        this.submittedForward = false;
                        this.forwardRemark = "";
                        $("#forwardModal").modal('show');
                        return [3 /*break*/, 10];
                    case 9:
                        this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น");
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.confirmForward = function () {
        this.submittedForward = true;
        if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
            this.form.controls["dpa_owningteamid"].setValue(this.forwardTeam);
            this.form.controls["dpa_caseowner"].setValue(this.userIdReceive);
            this.form.controls["dpa_assignby"].setValue(this.cookieData.userId);
            this.form.controls["dpa_remark"].setValue(this.forwardRemark);
            this.save(false, true);
        }
    };
    CustomerProfileComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
    };
    CustomerProfileComponent.prototype.normal = function () {
        $(".crisis").hide();
    };
    CustomerProfileComponent.prototype.crisis = function () {
        $(".crisis").show();
    };
    CustomerProfileComponent.prototype.viewAccountList = function () {
        $("#accountListModal").modal("show");
    };
    CustomerProfileComponent.prototype.close = function () {
        window.close();
    };
    CustomerProfileComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    CustomerProfileComponent.prototype.initViewMode = function (contact) {
        return __awaiter(this, void 0, void 0, function () {
            var idNo, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.GetDataSave.emit(contact[0]);
                        this.accNoSearchDROS = contact[0].dpa_accountno;
                        this.mapDataToForm(contact[0]);
                        idNo = "";
                        if (contact[0]["dpa_idcard"] != null && contact[0]["dpa_idcard"].trim().length > 0) {
                            idNo = contact[0]["dpa_idcard"];
                        }
                        else if (contact[0]["dpa_passport"] != null && contact[0]["dpa_passport"].trim().length > 0) {
                            idNo = contact[0]["dpa_passport"];
                        }
                        else if (contact[0]["dpa_registrationid"] != null && contact[0]["dpa_registrationid"].trim().length > 0) {
                            idNo = contact[0]["dpa_registrationid"];
                        }
                        this.getDrosContact(idNo, contact[0]["telephone1"]);
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.contactId)];
                    case 1:
                        _a.approvalTicket = _b.sent();
                        this.isDOPA = contact[0].dpa_dopaflag;
                        this.isNDID = contact[0].dpa_ndidflag;
                        if (this.approvalTicket != null && this.approvalTicket.length > 0 &&
                            this.approvalTicket[0].dpa_approvalstatuscode != null &&
                            this.approvalTicket[0].dpa_approvalstatuscode == "03") {
                            this.isAgentBank = true;
                        }
                        else {
                            this.isAgentBank = false;
                        }
                        this.createdon = new Date();
                        this.modifiedon = new Date();
                        this.form.controls["dpa_createdby"].setValue(this.cookieData.userId);
                        this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId);
                        this.createBy = this.cookieData.dpa_name;
                        this.modifiedBy = this.cookieData.dpa_name;
                        this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId);
                        this.form.controls["firstname"].setValue(contact[0]["firstname"]);
                        this.form.controls["lastname"].setValue(contact[0]["lastname"]);
                        this.form.controls["telephone1"].setValue(contact[0]["telephone1"]);
                        this.form.controls["dpa_otherphone"].setValue(contact[0]["dpa_otherphone"]);
                        this.form.controls["emailaddress1"].setValue(contact[0]["emailaddress1"]);
                        this.dpa_allowsms = contact[0]["dpa_allowsms"];
                        this.dpa_allowemail = contact[0]["dpa_allowemail"];
                        this.dpa_pdpa_flag = contact[0]["dpa_pdpa_flag"];
                        this.createContactOn = contact[0]["createdon"];
                        this.createContactBy = contact[0]["dpa_createdbyname"];
                        this.modifyContactOn = contact[0]["modifiedon"];
                        this.modifyContactBy = contact[0]["dpa_modifiedbyname"];
                        this.form.controls["customerid"].setValue(this.contactId);
                        this.form.controls["contactid"].setValue(this.contactId);
                        if (this.dpa_pdpa_flag) {
                            $("#ra1")[0].checked = true;
                            $("#ra2")[0].checked = false;
                        }
                        else {
                            $("#ra1")[0].checked = false;
                            $("#ra2")[0].checked = true;
                        }
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomerProfileComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerProfileComponent.prototype, "email", {
        get: function () {
            return this.form.value.emailaddress1.trim();
        },
        enumerable: true,
        configurable: true
    });
    CustomerProfileComponent.prototype.onForwardTeamChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.agentList.filter(function (a) {
                            return a.dpa_teamidlist.map(function (ag) { return ag.dpa_callcenterteamid; }).indexOf(_this.forwardTeam) > -1;
                        })];
                    case 1:
                        tmp = _a.sent();
                        this.userList = [];
                        tmp.forEach(function (a) {
                            if (_this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != _this.cookieData.userId) {
                                _this.userList.push(a);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.save = function (close, closeForward) {
        if (close === void 0) { close = false; }
        if (closeForward === void 0) { closeForward = false; }
        return __awaiter(this, void 0, void 0, function () {
            var updateSucceed, notiReq, updateSucceed, notiReq;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if ((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
                            (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0)) {
                            return [2 /*return*/];
                        }
                        if (!this.form.valid) return [3 /*break*/, 8];
                        //set team
                        if (this.myTeams != null && this.myTeams.length > 0) {
                            this.formControl["dpa_owningteamid"].setValue(this.myTeams[0].dpa_callcenterteamid);
                        }
                        else {
                            this.formControl["dpa_owningteamid"].setValue(null);
                        } //set team
                        this.form.controls["dpa_pdpa_flag"].setValue($('#ra1')[0].checked);
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.updateContact()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.registerDROS()];
                    case 2:
                        _a.sent();
                        this.GetDataSave.emit(this.form.getRawValue());
                        if (!(this.formControl["incidentid"].value != null && this.formControl["incidentid"].value != "")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.updateCase()];
                    case 3:
                        //update for tester request
                        if (_a.sent()) {
                            this.checkIsSaveCloseCase();
                            this.util.ShowWaiting(false);
                            if (closeForward) {
                                this.util.SuccessDialog("ส่งต่อ Case สำเร็จ");
                            }
                            else {
                                this.util.SuccessDialog("บันทึก case สำเร็จ");
                            }
                            if (close) {
                                window.close();
                            }
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                        }
                        if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.formControl["emailaddress1"].value) {
                            updateSucceed = this.updatePortalLogin();
                            notiReq = {
                                firstname: this.formControl["firstname"].value,
                                lastname: this.formControl["lastname"].value,
                                callBy: "1",
                                newMail: this.formControl["emailaddress1"].value,
                                oldMail: this.oldEmail
                            };
                            this.apiService.postCustom("crm", "NotiEmailChange", notiReq);
                        }
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.createCase()];
                    case 5:
                        if (_a.sent()) {
                            this.checkIsSaveCloseCase();
                            this.util.ShowWaiting(false);
                            if (closeForward) {
                                this.util.SuccessDialog("ส่งต่อ Case สำเร็จ");
                            }
                            else {
                                this.util.SuccessDialog("เพิ่ม case สำเร็จ");
                            }
                            if (close) {
                                window.close();
                            }
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                        }
                        if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.formControl["emailaddress1"].value) {
                            updateSucceed = this.updatePortalLogin();
                            notiReq = {
                                firstname: this.formControl["firstname"].value,
                                lastname: this.formControl["lastname"].value,
                                callBy: "1",
                                newMail: this.formControl["emailaddress1"].value,
                                oldMail: this.oldEmail
                            };
                            this.apiService.postCustom("crm", "NotiEmailChange", notiReq);
                        }
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (closeForward) {
                            this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("เพิ่ม case ไม่สำเร็จ");
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.createCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), true)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.formControl["incidentid"].setValue(res.incidentid);
                            return [2 /*return*/, true];
                        }
                        else {
                            //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.updateContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.put("crmservice", "contact/" + this.form.get("contactid").value, this.form.getRawValue())];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) {
                            //this.util.ErrorDialog("แก้ไข Contact ไม่สำเร็จ")
                            return [2 /*return*/, false];
                        }
                        else {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.onCaseTypeChange = function () {
        var _this = this;
        this.caseSubTypeList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.form.get("dpa_casetypeid").value; });
        this.form.get("dpa_casesubtypeid").setValue("");
        this.onCaseSubTypeChange();
    };
    CustomerProfileComponent.prototype.onCaseSubTypeChange = function () {
        var _this = this;
        this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(function (s) {
            return s.dpa_casesubtypeid === _this.form.get("dpa_casesubtypeid").value;
        });
        this.form.get("dpa_casesubtypedetailid").setValue("");
    };
    CustomerProfileComponent.prototype.filterByType = function (type) {
        this.util.ShowWaiting(true);
        this.showingKBList = this.kmList.filter(function (kb) {
            if (type === kb.dpa_knowledgebasetype) {
                return true;
            }
        });
        this.util.ShowWaiting(false);
    };
    CustomerProfileComponent.prototype.filterKm = function () {
        var _this = this;
        this.util.ShowWaiting(true);
        this.kmCriteria = $("#kmCriContact").val();
        if (this.kmCriteria != null && this.kmCriteria.trim().length == 0) {
            this.showingKBList = [];
        }
        else {
            this.showingKBList = this.kmList.filter(function (kb) {
                if (kb.dpa_keyword != null && kb.dpa_keyword.includes(_this.kmCriteria)) {
                    return true;
                }
            });
        }
        this.util.ShowWaiting(false);
    };
    CustomerProfileComponent.prototype.onCaseStatusChange = function () {
        var _this = this;
        var status = this.caseStatusList.filter(function (c) {
            return c.dpa_casestatusid == _this.form.controls["dpa_casestatusid"].value;
        });
        if (status != null && status.length > 0) {
            if (status[0].dpa_code == "04") {
                this.isRemarkRequired = true;
            }
            else {
                this.isRemarkRequired = false;
            }
            if (status[0].dpa_code == "03") {
                this.isResolvedRequired = true;
            }
            else {
                this.isResolvedRequired = false;
            }
        }
    };
    CustomerProfileComponent.prototype.mapDataToForm = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (_this.form.controls[key]) {
                _this.form.controls[key].setValue(data[key]);
            }
            else {
                _this.form.addControl(key, new FormControl(data[key]));
            }
        });
    };
    CustomerProfileComponent.prototype.openKm = function () {
        var url = this.util.baseUrl() + "/mainmenu/knowledge/";
        window.open(url, '_blank');
    };
    CustomerProfileComponent.prototype.checkIsSaveCloseCase = function () {
        if (this.isRemarkRequired || this.isResolvedRequired) {
            this.isEndCase = true;
            $("#form :input").prop("disabled", true);
            $("#btnKm").prop("disabled", false);
        }
    };
    CustomerProfileComponent.prototype.drawDepositAccountTable = function (accountList) {
        if (accountList === void 0) { accountList = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        try {
                            $('#tbSharedCase').DataTable().clear().destroy();
                        }
                        catch (e) {
                        }
                        $("#accountTable tbody").empty();
                        if (!(accountList != null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "bank")];
                    case 1:
                        _a.bankList = _b.sent();
                        accountList.forEach(function (b) {
                            var tr = "<tr>";
                            var bankName = _this.bankList.filter(function (mb) {
                                return mb.dpa_bankcode == b.BankCode;
                            });
                            if (bankName != null && bankName.length > 0) {
                                tr += "<td>" + (bankName[0].dpa_name || "") + "</td>";
                            }
                            else {
                                tr += "<td></td>";
                            }
                            tr += "<td>" + (b.BankAccountNo || "") + "</td>";
                            tr += "<td>" + (b.BankAccountName || "") + "</td>";
                            // tr += "<td>" + (b.BankCode || "") + " </td>"
                            tr += "<td>" + (b.BankAccountStatus || "") + "</td>";
                            tr += "<td>" + (b.BankAccountType || "") + "</td>";
                            tr += "</tr>";
                            $("#accountTable tbody").append(tr);
                        });
                        _b.label = 2;
                    case 2:
                        $("#accountTable").dataTable({
                            retrieve: true,
                            'searching': false,
                            'paging': true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.getDrosContact = function (idNo, phoneNo, accNo) {
        if (accNo === void 0) { accNo = null; }
        return __awaiter(this, void 0, void 0, function () {
            var para, contactDros;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "CRM06=true&CRM07=true";
                        if (idNo != null && idNo.trim().length != 0) {
                            para += "&dpa_id=" + idNo;
                        }
                        if (phoneNo != null && phoneNo.trim().length != 0) {
                            para += "&telephoneno=" + phoneNo;
                        }
                        if (accNo != null && accNo.trim().length != 0) {
                            para += "&dpa_accountno=" + accNo;
                        }
                        if (!(para == "CRM06=true&CRM07=true")) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1: return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 2:
                        contactDros = _a.sent();
                        this.util.ShowWaiting(false);
                        if (!(contactDros == null || contactDros.length == 0)) return [3 /*break*/, 3];
                        return [3 /*break*/, 7];
                    case 3:
                        if (contactDros != null && contactDros.CRM06 != null) {
                            this.crm06 = contactDros.CRM06;
                            this.idNoSearchDROS = contactDros.CRM06.IDNo;
                        }
                        else {
                            this.crm06 = {};
                        }
                        if (!(contactDros != null && contactDros.CRM07 != null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.drawDepositAccountTable(contactDros.CRM07)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.drawDepositAccountTable()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.registerDROS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idcard, para, tmp, UID, SubdistictCode, PostalName, SubdistictObj, PostalObj, arrAddr, rowAddr, birthdateYYYYMMDD, rowSave, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idcard = this.contactToDros[0].dpa_idcard;
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        if (!!this.util.IsNullOrUndefined(tmp.CRM06)) return [3 /*break*/, 5];
                        UID = tmp.CRM06.UID;
                        SubdistictCode = "";
                        PostalName = "";
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Subdistrict", { id: this.contactToDros[0].dpa_contact_subdistict })];
                    case 2:
                        SubdistictObj = _a.sent();
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Postalcode", { id: this.contactToDros[0].dpa_contact_postcode })];
                    case 3:
                        PostalObj = _a.sent();
                        if (!this.util.IsNullOrUndefined(SubdistictObj)) {
                            SubdistictCode = SubdistictObj[0].dpa_code;
                        }
                        0;
                        if (!this.util.IsNullOrUndefined(PostalObj)) {
                            PostalName = PostalObj[0].dpa_name;
                        }
                        arrAddr = [];
                        rowAddr = {
                            addressType: "2",
                            addressNo: this.contactToDros[0].dpa_contact_homeno,
                            villageName: null,
                            floor: null,
                            mooNo: this.contactToDros[0].dpa_contact_moo,
                            soiName: null,
                            streetName: this.contactToDros[0].dpa_contact_street,
                            locationCode: SubdistictCode,
                            zipcode: PostalName
                        };
                        birthdateYYYYMMDD = "";
                        if (this.contactToDros[0].birthdate != "") {
                            birthdateYYYYMMDD = moment(this.contactToDros[0].birthdate).format("YYYY/MM/DD");
                        }
                        arrAddr.push(rowAddr);
                        rowSave = {
                            uid: UID,
                            idNo: idcard,
                            title: null,
                            firstName: this.formControl["firstname"].value,
                            lastName: this.formControl["lastname"].value,
                            birthdate: birthdateYYYYMMDD,
                            mobileNo: this.formControl["telephone1"].value,
                            email: this.formControl["emailaddress1"].value,
                            address: arrAddr
                        };
                        return [4 /*yield*/, this.apiService.post("DROS", "register", rowSave)];
                    case 4:
                        Res = _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // async SendNewEmail() {
    //   let MailObj: any = {
    //     dpa_name: "อีเมลของท่านได้รับการเปลี่ยนแล้ว",
    //     dpa_emailaddress: this.formControl["emailaddress1"].value
    //   };
    //   var MailContent = "เรียน คุณ" + this.formControl["firstname"].value + " " + this.formControl["lastname"].value + "<br /><br />" +
    //     "   อีเมลนี้ของคุณได้รับการบันทึกในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
    //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด  <br /><br />" +
    //     "ขอแสดงความนับถือ <br />" +
    //     "สถาบันคุ้มครองเงินฝาก <br />" +
    //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
    //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
    //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
    //     "โทร : 02-272-0300";
    //   MailObj.dpa_description = MailContent;
    //   MailObj.dpa_callby = 1
    //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    //   return Res;
    // }
    // async SendOldEmail() {
    //   let MailObj: any = {
    //     dpa_name: "อีเมลของท่านได้ถูกเปลี่ยนแล้ว",
    //     dpa_emailaddress: this.oldEmail
    //   };
    //   var MailContent = "เรียน คุณ" + this.formControl["firstname"].value + " " + this.formControl["lastname"].value + "<br /><br />" +
    //     "   อีเมลของคุณได้เปลี่ยนในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
    //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด <br /><br />" +
    //     "ขอแสดงความนับถือ <br />" +
    //     "สถาบันคุ้มครองเงินฝาก <br />" +
    //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
    //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
    //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
    //     "โทร : 02-272-0300";
    //   MailObj.dpa_description = MailContent;
    //   MailObj.dpa_callby = 1
    //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    //   return Res;
    // }
    CustomerProfileComponent.prototype.updatePortalLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            username: this.formControl["emailaddress1"].value,
                            usernameidno: this.formControl["dpa_idcard"].value,
                            oldEmail: this.oldEmail
                        };
                        return [4 /*yield*/, this.apiService.postCustom("User", "UpdateEmailLogin", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerProfileComponent.prototype.updateCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.put("crmservice", "caseIncident/" + this.form.get("incidentid").value, this.form.getRawValue())];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CustomerProfileComponent;
}());
export { CustomerProfileComponent };



// WEBPACK FOOTER //
// ./src/app/customer-profile/customer-profile.component.ts.pre-build-optimizer.js